import { render, staticRenderFns } from "./FormatList.vue?vue&type=template&id=cd1e2fc0&scoped=true"
import script from "./FormatList.vue?vue&type=script&lang=js"
export * from "./FormatList.vue?vue&type=script&lang=js"
import style0 from "./FormatList.vue?vue&type=style&index=0&id=cd1e2fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1e2fc0",
  null
  
)

export default component.exports